<script>
import {checkExtension, checkSize} from "@/components/libs/extension";

export default {
  name: "FileField",
  props: {
    customData: Object,
  },
  emits: [
      'destroy',
      'created',
      'validate',
  ],
  created() {

    //save index element in data
    this.index = this.customData.index

    //save allowed extensions in data
    this.allowedExtension = this.customData.allowedExtension

  },
  computed: {
    showRemove() {
      // return this.index;
      if( this.index === 0 && this.fileErrorObject === null ) {
        return false
      }

      return true;
    },

    fileError() {

      if (this.fileErrorObject === null) {
        return false
      }

      return !this.fileErrorObject.success

    },

    fileErrorMessage() {
      return this.fileErrorObject === null ?  '' : this.fileErrorObject.message
    },

  },
  mounted() {

    const item = this.$refs['fileUploadRef' + '_' + this.index]

    //сообщаю родителю, что я создался с заданными параметрами
    this.$emit('created', {index: this.index, ref: item})


  },
  data() {
    return {
      id: null,
      index: null,
      uploadFileName: '',
      allowedExtension: [],
      fileErrorObject: null,
    }
  },
  methods: {

    checkFileExtension({event}) {

      let name = ''
      let size = 0

      if(event.target.files.length) {
        name = event.target.files[0].name
        size = event.target.files[0].size
      }

      // console.log('file details', event.target.files[0])

      this.uploadFileName = name
      this.fileErrorObject = checkExtension({filename: name, allowedExtension: this.allowedExtension})

      //проверяем размер только если с расширением файла все ок
      if(this.fileErrorObject.success) {
        //check file size
        this.fileErrorObject = checkSize({size: size, maxSize: 1073741824})
      }

      // console.log('this.fileErrorObject', this.fileErrorObject)
      this.$emit('validate', {fileErrorObject: this.fileErrorObject, index: this.index })

    },

    destroyComponent(event) {
      event.preventDefault()

      this.fileErrorObject = null

      if ( this.index === 0 ) {
        const input = this.$refs['fileUploadRef_' + this.index]
        input.value = ''
        this.uploadFileName = ''
      }

      // говорю родителю, что меня решили уничтожить
      this.$emit('destroy', this.index)
    },

  },

}
</script>

<template>
  <div
      class="input-field field-mask input-field-file"
      :class="{'file-selected' : uploadFileName !== '', 'field-error': fileError }"
  >

    <input
        :ref="'fileUploadRef' + '_' + index"
        type="file"
        class="input hidden"
        v-on:change="checkFileExtension({event: $event })"
        :id="'download_file' + '_' + index"
    >

    <template v-if="showRemove"> <!--show if index not 0-->
      <button style="display: block" @click="destroyComponent($event)" class="remove-file-field-button"></button>
    </template>

    <div class="input">
      <div> {{uploadFileName}} </div>

      <label
          :for="'download_file' + '_' + index"
          class="label">Attach a File (optional)
      </label>
    </div>

    <label
        :for="'download_file' + '_' + index"
        class="input-file">Upload ...
    </label>
    
  </div>
<span v-if="fileError" v-html="fileErrorMessage" class="error"></span>
<div class="input-hint">Supported formats: .pdf, .zip, .tar.gz, .7z, .log, .txt, .jpeg, .png. Maximum size per file: 1GB</div>
</template>

<style scoped>
:deep(.field-mask.input-field-file div div ) {
  padding: 16px 25px;
}

.input-hint {
  color: #576680;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  margin-top: -10px;
  margin-bottom: 20px;
  padding-left: 26px;
}

.remove-file-field-button {
  color: #0a4cb5;
  position: absolute;
  padding: 0;
  margin: 0;
  background-color: #ffffff;
  border: 1px solid #0a4cb5;
  width: 20px;
  height: 20px;
  top: -10px;
  left: -9px;
  border-radius: 50%;
  cursor: pointer;
  transition: .2s;
  z-index: 2;
}

.remove-file-field-button:hover {
  border-color: #0A3B89;
  color: #0A3B89;
}

.remove-file-field-button:before {
  content: "\00d7";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    font-size: 16px;
    display: block;
    z-index: 1;
}

.form-main .input-field.field-mask {
  height: auto;
}

.form-main .input-field.field-mask .input {
  height: 54px;
}

/* .form-main .input-field.field-mask:not(:first-child) .label {
  color: #576697;
} */

.form-main .input-field .input div {
  padding: 16px 20px;
  height: 54px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}

body .form-main .input-field.field-error.input-field-file label {
  color: #C90A0A;
}

.form-main .input-field.field-mask + .error {
  margin-top: -12px;
  margin-bottom: 20px;
}

.form-main .input-field.field-mask.file-selected .label {
  left: 12px;
}

</style>